import type { AccessDecision } from '../../../core/components/PermissionGuard/PermissionGuard';

type ResolveAdmPanelAccessParams = {
  flagEnabled: boolean;
  isChecking: boolean;
  hasPermission: boolean;
};

/**
 * Convenience, not security. The real boundary is the server-side `AdminJobTitle` policy in the
 * ExperienceApi, and the menu entry is already absent for a non-admin because the API prunes the
 * branch. This exists so someone who types the URL sees a redirect instead of a shell whose every
 * call 403s.
 */
export const resolveAdmPanelAccess = ({
  flagEnabled,
  isChecking,
  hasPermission,
}: ResolveAdmPanelAccessParams): AccessDecision => {
  if (!flagEnabled) return 'deny';
  if (isChecking) return 'loading';
  if (!hasPermission) return 'deny';
  return 'allow';
};
